// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * (c) Copyright Ascensio System SIA 2009-2024
 * 
 * This program is a free software product.
 * You can redistribute it and/or modify it under the terms
 * of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
 * Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
 * to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
 * any third-party rights.
 * 
 * This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
 * the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
 * 
 * You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
 * 
 * The  interactive user interfaces in modified source and object code versions of the Program must
 * display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
 * 
 * Pursuant to Section 7(b) of the License you must retain the original Product logo when
 * distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
 * trademark law for use of our trademarks.
 * 
 * All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
 * content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
 * International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode
 */

.smartbanner-show.smartbanner-margin-top {
  margin-top: 0px;
}
.smartbanner-show.smartbanner-margin-bottom {
  margin-bottom: 0px;
}
.smartbanner-show .smartbanner {
  display: block;
}
.smartbanner {
  inset-inline-start: 0;
  display: none;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-family:
    Helvetica Neue,
    sans-serif;
  background: #f4f4f4;
  z-index: 100;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  -webkit-text-size-adjust: none;
}
.smartbanner-top {
  position: absolute;
  top: 0;
}
.smartbanner-bottom {
  position: fixed;
  bottom: 0;
}
.smartbanner-container {
  margin: 0 auto;
  padding: 0 5px;
}
.smartbanner-close {
  display: inline-block;
  vertical-align: middle;
  margin-block: 0;
  margin-inline: 0 5px;
  font-family: ArialRoundedMTBold, Arial;
  font-size: 20px;
  text-align: center;
  color: #888;
  text-decoration: none;
  border: 0;
  border-radius: 14px;
  padding: 0 0 1px;
  background-color: transparent;
  -webkit-font-smoothing: subpixel-antialiased;
}
.smartbanner-close:active,
.smartbanner-close:hover {
  color: #aaa;
}
.smartbanner-icon {
  width: 57px;
  height: 57px;
  margin-inline-end: 12px;
  background-size: cover;
  border-radius: 10px;
}
.smartbanner-icon,
.smartbanner-info {
  display: inline-block;
  vertical-align: middle;
}
.smartbanner-info {
  white-space: normal;
  width: calc(99% - 201px);
  font-size: 11px;
  line-height: 1.2em;
  font-weight: 700;
}
.smartbanner-wrapper {
  max-width: 110px;
  display: inline-block;
  text-align: end;
  width: 100%;
}
.smartbanner-title {
  font-size: 13px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.smartbanner-description {
  max-height: 40px;
  overflow: hidden;
}
.smartbanner-author {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.smartbanner-author:empty + .smartbanner-description {
  max-height: 50px;
}
.smartbanner-button {
  margin: auto 0;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  font-weight: 700;
  color: #6a6a6a;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);
}
.smartbanner-button:active,
.smartbanner-button:hover {
  color: #aaa;
}
.smartbanner-ios {
  background: #f2f2f2;
  line-height: 80px;
}
.smartbanner-ios .smartbanner-close {
  border: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-family: Arial;
  color: #888;
  text-shadow: 0 1px 0 #fff;
  -webkit-font-smoothing: none;
}
.smartbanner-ios .smartbanner-close:active,
.smartbanner-ios .smartbanner-close:hover {
  color: #888;
}
.smartbanner-ios .smartbanner-icon {
  background-size: cover;
}
.smartbanner-ios .smartbanner-info {
  color: #6a6a6a;
  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);
  font-weight: 300;
}
.smartbanner-ios .smartbanner-title {
  color: #4d4d4d;
  font-weight: 500;
}
.smartbanner-ios .smartbanner-button {
  padding: 0 10px;
  font-size: 15px;
  min-width: 10%;
  font-weight: 400;
  color: #0c71fd;
}
.smartbanner-ios .smartbanner-button:active,
.smartbanner-ios .smartbanner-button:hover {
  background: #f2f2f2;
}
.smartbanner-android {
  background: #3d3d3d
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow: inset 0 4px 0 #88b131;
  line-height: 82px;
}
.smartbanner-android .smartbanner-close {
  border: 0;
  max-width: 17px;
  width: 100%;
  height: 17px;
  line-height: 17px;
  margin-inline-end: 7px;
  color: #b1b1b3;
  background: #1c1e21;
  text-shadow: 0 1px 1px #000;
  text-decoration: none;
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.8),
    0 1px 1px hsla(0, 0%, 100%, 0.3);
  cursor: pointer;
}
.smartbanner-android .smartbanner-close:active,
.smartbanner-android .smartbanner-close:hover {
  color: #eee;
}
.smartbanner-android .smartbanner-icon {
  background-color: transparent;
  box-shadow: none;
}
.smartbanner-android .smartbanner-info {
  color: #ccc;
  text-shadow: 0 1px 2px #000;
}
.smartbanner-android .smartbanner-title {
  color: #fff;
  font-weight: 700;
}
.smartbanner-android .smartbanner-button {
  min-width: 12%;
  color: #d1d1d1;
  font-weight: 700;
  padding: 0;
  background: none;
  border-radius: 0;
  box-shadow:
    0 0 0 1px #333,
    0 0 0 2px #dddcdc;
}
.smartbanner-android .smartbanner-button:active,
.smartbanner-android .smartbanner-button:hover {
  background: none;
}
.smartbanner-android .smartbanner-button-text {
  text-align: center;
  display: block;
  padding: 0 10px;
  background: #42b6c9;
  background: linear-gradient(180deg, #42b6c9, #39a9bb);
  text-transform: none;
  text-shadow: none;
  box-shadow: none;
}
.smartbanner-android .smartbanner-button-text:active,
.smartbanner-android .smartbanner-button-text:hover {
  background: #2ac7e1;
}
.smartbanner-kindle,
.smartbanner-windows {
  background: #f4f4f4;
  background: linear-gradient(180deg, #f4f4f4, #cdcdcd);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  line-height: 80px;
}
.smartbanner-kindle .smartbanner-close,
.smartbanner-windows .smartbanner-close {
  border: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #888;
  text-shadow: 0 1px 0 #fff;
}
.smartbanner-kindle .smartbanner-close:active,
.smartbanner-kindle .smartbanner-close:hover,
.smartbanner-windows .smartbanner-close:active,
.smartbanner-windows .smartbanner-close:hover {
  color: #aaa;
}
.smartbanner-kindle .smartbanner-icon,
.smartbanner-windows .smartbanner-icon {
  background: rgba(0, 0, 0, 0.6);
  background-size: cover;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.smartbanner-kindle .smartbanner-info,
.smartbanner-windows .smartbanner-info {
  color: #6a6a6a;
  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);
}
.smartbanner-kindle .smartbanner-title,
.smartbanner-windows .smartbanner-title {
  color: #4d4d4d;
  font-weight: 700;
}
.smartbanner-kindle .smartbanner-button,
.smartbanner-windows .smartbanner-button {
  padding: 0 10px;
  min-width: 10%;
  color: #6a6a6a;
  background: #efefef;
  background: linear-gradient(180deg, #efefef, #dcdcdc);
  border-radius: 3px;
  box-shadow:
    inset 0 0 0 1px #bfbfbf,
    0 1px 0 hsla(0, 0%, 100%, 0.6),
    inset 0 2px 0 hsla(0, 0%, 100%, 0.7);
}
.smartbanner-kindle .smartbanner-button:active,
.smartbanner-kindle .smartbanner-button:hover,
.smartbanner-windows .smartbanner-button:active,
.smartbanner-windows .smartbanner-button:hover {
  background: #dcdcdc;
  background: linear-gradient(180deg, #dcdcdc, #efefef);
}
`, "",{"version":3,"sources":["webpack://./src/components/SmartBanner/main.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE;;AAEF;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;cAEY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;;EAEE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;2CACuG;EACvG,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB;;oCAEkC;EAClC,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB;;qBAEmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qDAAqD;EACrD,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,qDAAqD;EACrD,wCAAwC;EACxC,iBAAiB;AACnB;AACA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;AACA;;;;EAIE,WAAW;AACb;AACA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;;EAEE,cAAc;EACd,2CAA2C;AAC7C;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB;;;wCAGsC;AACxC;AACA;;;;EAIE,mBAAmB;EACnB,qDAAqD;AACvD","sourcesContent":["/**\n * (c) Copyright Ascensio System SIA 2009-2024\n * \n * This program is a free software product.\n * You can redistribute it and/or modify it under the terms\n * of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software\n * Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended\n * to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of\n * any third-party rights.\n * \n * This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty\n * of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see\n * the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html\n * \n * You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.\n * \n * The  interactive user interfaces in modified source and object code versions of the Program must\n * display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.\n * \n * Pursuant to Section 7(b) of the License you must retain the original Product logo when\n * distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under\n * trademark law for use of our trademarks.\n * \n * All the Product's GUI elements, including illustrations and icon sets, as well as technical writing\n * content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0\n * International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode\n */\n\n.smartbanner-show.smartbanner-margin-top {\n  margin-top: 0px;\n}\n.smartbanner-show.smartbanner-margin-bottom {\n  margin-bottom: 0px;\n}\n.smartbanner-show .smartbanner {\n  display: block;\n}\n.smartbanner {\n  inset-inline-start: 0;\n  display: none;\n  width: 100%;\n  height: 80px;\n  line-height: 80px;\n  font-family:\n    Helvetica Neue,\n    sans-serif;\n  background: #f4f4f4;\n  z-index: 100;\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden;\n  -webkit-text-size-adjust: none;\n}\n.smartbanner-top {\n  position: absolute;\n  top: 0;\n}\n.smartbanner-bottom {\n  position: fixed;\n  bottom: 0;\n}\n.smartbanner-container {\n  margin: 0 auto;\n  padding: 0 5px;\n}\n.smartbanner-close {\n  display: inline-block;\n  vertical-align: middle;\n  margin-block: 0;\n  margin-inline: 0 5px;\n  font-family: ArialRoundedMTBold, Arial;\n  font-size: 20px;\n  text-align: center;\n  color: #888;\n  text-decoration: none;\n  border: 0;\n  border-radius: 14px;\n  padding: 0 0 1px;\n  background-color: transparent;\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n.smartbanner-close:active,\n.smartbanner-close:hover {\n  color: #aaa;\n}\n.smartbanner-icon {\n  width: 57px;\n  height: 57px;\n  margin-inline-end: 12px;\n  background-size: cover;\n  border-radius: 10px;\n}\n.smartbanner-icon,\n.smartbanner-info {\n  display: inline-block;\n  vertical-align: middle;\n}\n.smartbanner-info {\n  white-space: normal;\n  width: calc(99% - 201px);\n  font-size: 11px;\n  line-height: 1.2em;\n  font-weight: 700;\n}\n.smartbanner-wrapper {\n  max-width: 110px;\n  display: inline-block;\n  text-align: end;\n  width: 100%;\n}\n.smartbanner-title {\n  font-size: 13px;\n  line-height: 18px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.smartbanner-description {\n  max-height: 40px;\n  overflow: hidden;\n}\n.smartbanner-author {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.smartbanner-author:empty + .smartbanner-description {\n  max-height: 50px;\n}\n.smartbanner-button {\n  margin: auto 0;\n  height: 24px;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  font-weight: 700;\n  color: #6a6a6a;\n  text-transform: uppercase;\n  text-decoration: none;\n  display: inline-block;\n  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);\n}\n.smartbanner-button:active,\n.smartbanner-button:hover {\n  color: #aaa;\n}\n.smartbanner-ios {\n  background: #f2f2f2;\n  line-height: 80px;\n}\n.smartbanner-ios .smartbanner-close {\n  border: 0;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  font-family: Arial;\n  color: #888;\n  text-shadow: 0 1px 0 #fff;\n  -webkit-font-smoothing: none;\n}\n.smartbanner-ios .smartbanner-close:active,\n.smartbanner-ios .smartbanner-close:hover {\n  color: #888;\n}\n.smartbanner-ios .smartbanner-icon {\n  background-size: cover;\n}\n.smartbanner-ios .smartbanner-info {\n  color: #6a6a6a;\n  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);\n  font-weight: 300;\n}\n.smartbanner-ios .smartbanner-title {\n  color: #4d4d4d;\n  font-weight: 500;\n}\n.smartbanner-ios .smartbanner-button {\n  padding: 0 10px;\n  font-size: 15px;\n  min-width: 10%;\n  font-weight: 400;\n  color: #0c71fd;\n}\n.smartbanner-ios .smartbanner-button:active,\n.smartbanner-ios .smartbanner-button:hover {\n  background: #f2f2f2;\n}\n.smartbanner-android {\n  background: #3d3d3d\n    url(\"data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7\");\n  box-shadow: inset 0 4px 0 #88b131;\n  line-height: 82px;\n}\n.smartbanner-android .smartbanner-close {\n  border: 0;\n  max-width: 17px;\n  width: 100%;\n  height: 17px;\n  line-height: 17px;\n  margin-inline-end: 7px;\n  color: #b1b1b3;\n  background: #1c1e21;\n  text-shadow: 0 1px 1px #000;\n  text-decoration: none;\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.8),\n    0 1px 1px hsla(0, 0%, 100%, 0.3);\n  cursor: pointer;\n}\n.smartbanner-android .smartbanner-close:active,\n.smartbanner-android .smartbanner-close:hover {\n  color: #eee;\n}\n.smartbanner-android .smartbanner-icon {\n  background-color: transparent;\n  box-shadow: none;\n}\n.smartbanner-android .smartbanner-info {\n  color: #ccc;\n  text-shadow: 0 1px 2px #000;\n}\n.smartbanner-android .smartbanner-title {\n  color: #fff;\n  font-weight: 700;\n}\n.smartbanner-android .smartbanner-button {\n  min-width: 12%;\n  color: #d1d1d1;\n  font-weight: 700;\n  padding: 0;\n  background: none;\n  border-radius: 0;\n  box-shadow:\n    0 0 0 1px #333,\n    0 0 0 2px #dddcdc;\n}\n.smartbanner-android .smartbanner-button:active,\n.smartbanner-android .smartbanner-button:hover {\n  background: none;\n}\n.smartbanner-android .smartbanner-button-text {\n  text-align: center;\n  display: block;\n  padding: 0 10px;\n  background: #42b6c9;\n  background: linear-gradient(180deg, #42b6c9, #39a9bb);\n  text-transform: none;\n  text-shadow: none;\n  box-shadow: none;\n}\n.smartbanner-android .smartbanner-button-text:active,\n.smartbanner-android .smartbanner-button-text:hover {\n  background: #2ac7e1;\n}\n.smartbanner-kindle,\n.smartbanner-windows {\n  background: #f4f4f4;\n  background: linear-gradient(180deg, #f4f4f4, #cdcdcd);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n  line-height: 80px;\n}\n.smartbanner-kindle .smartbanner-close,\n.smartbanner-windows .smartbanner-close {\n  border: 0;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  color: #888;\n  text-shadow: 0 1px 0 #fff;\n}\n.smartbanner-kindle .smartbanner-close:active,\n.smartbanner-kindle .smartbanner-close:hover,\n.smartbanner-windows .smartbanner-close:active,\n.smartbanner-windows .smartbanner-close:hover {\n  color: #aaa;\n}\n.smartbanner-kindle .smartbanner-icon,\n.smartbanner-windows .smartbanner-icon {\n  background: rgba(0, 0, 0, 0.6);\n  background-size: cover;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n.smartbanner-kindle .smartbanner-info,\n.smartbanner-windows .smartbanner-info {\n  color: #6a6a6a;\n  text-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.8);\n}\n.smartbanner-kindle .smartbanner-title,\n.smartbanner-windows .smartbanner-title {\n  color: #4d4d4d;\n  font-weight: 700;\n}\n.smartbanner-kindle .smartbanner-button,\n.smartbanner-windows .smartbanner-button {\n  padding: 0 10px;\n  min-width: 10%;\n  color: #6a6a6a;\n  background: #efefef;\n  background: linear-gradient(180deg, #efefef, #dcdcdc);\n  border-radius: 3px;\n  box-shadow:\n    inset 0 0 0 1px #bfbfbf,\n    0 1px 0 hsla(0, 0%, 100%, 0.6),\n    inset 0 2px 0 hsla(0, 0%, 100%, 0.7);\n}\n.smartbanner-kindle .smartbanner-button:active,\n.smartbanner-kindle .smartbanner-button:hover,\n.smartbanner-windows .smartbanner-button:active,\n.smartbanner-windows .smartbanner-button:hover {\n  background: #dcdcdc;\n  background: linear-gradient(180deg, #dcdcdc, #efefef);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
